export const signIn = "/sign-in";
export const signUp = "/sign-up";
export const signOut = "/sign-out";
